import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { Button } from "./Button";
import { IconButton } from "./IconButton";
import { Menu } from "./Menu";
import { ExpandMoreOutline } from "../icons/icons";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const dropdownClasses = {
    root: "MinervaDropdown-root",
    button: "MinervaDropdown-button",
    "icon-button": "MinervaDropdown-iconButton",
    popper: "MinervaDropdown-popper",
};
export const dropdownSlots = {
    button: Button,
    iconButton: IconButton,
    expandIcon: ExpandMoreOutline,
};
export const dropdownVariants = ["button", "iconButton"];
export const Dropdown = (props) => {
    const { variant = "button", open: _open, label, onOpenChange, slots, slotProps, className, ...rest } = useDefaultProps({ component: "Dropdown", props });
    const [open, setOpen] = useState(_open ?? false);
    useEffect(() => {
        setOpen(_open ?? false);
    }, [_open]);
    return (_jsx(SlotsProvider, { baseSlots: dropdownSlots, slots: slots, children: ({ button: Button, iconButton: IconButton, expandIcon: ExpandIcon }) => {
            const expandIcon = (_jsx(ExpandIcon, { ...slotProps?.expandIcon, sx: mergeSx({
                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s",
                }, slotProps?.expandIcon?.sx) }));
            return (_jsx(Menu, { open: open, onOpenChange: (open) => {
                    onOpenChange?.(open);
                    setOpen(open);
                }, ...rest, children: variant === "button" ? (_jsx(Button, { variant: "outlined", density: "dense", ...slotProps?.button, endNode: slotProps?.button?.endNode ?? expandIcon, className: clsx([
                        dropdownClasses.button,
                        slotProps?.button?.className,
                    ]), children: label })) : (_jsx(IconButton, { variant: "outlined", density: "dense", ...slotProps?.iconButton, className: clsx([
                        dropdownClasses["icon-button"],
                        slotProps?.iconButton?.className,
                    ]), children: expandIcon })) }));
        } }));
};
//# sourceMappingURL=Dropdown.js.map